/**
 * @description
 * Behavior for a datepicker calendar grid cell.
 * The aria roles need to be explicitly added so that VPC mode is turned off when navigating the grid.
 * Thus the keyboard navigation works properly.
 * @specification
 * Adds role='none'.
 */
export var datepickerCalendarCellBehavior = function datepickerCalendarCellBehavior(props) {
  return {
    attributes: {
      root: {
        role: 'none'
      }
    }
  };
};
//# sourceMappingURL=datepickerCalendarCellBehavior.js.map
